import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { MyListProvider } from "@/context/MyListContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { AdminRoute } from "@/components/AdminRoute";
import { Toaster } from "@/components/ui/sonner";
import { TvNavigation } from "@/components/TvNavigation";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Channels from "@/pages/Channels";
import ChannelPage from "@/pages/ChannelPage";
import Watch from "@/pages/Watch";
import Dashboard from "@/pages/Dashboard";
import Admin from "@/pages/Admin";
import Search from "@/pages/Search";
import MyList from "@/pages/MyList";
import About from "@/pages/About";
import Refer from "@/pages/Refer";

function App() {
  return (
    <div className="App">
      <div className="noise-overlay" />
      <AuthProvider>
        <MyListProvider>
          <BrowserRouter>
            <TvNavigation />
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/channels" element={<Channels />} />
              <Route path="/about" element={<About />} />
              <Route path="/refer" element={<Refer />} />
              <Route path="/channel/:slug" element={<ChannelPage />} />
              <Route path="/watch/:id" element={<Watch />} />
              <Route path="/search" element={<Search />} />
              <Route
                path="/my-list"
                element={
                  <ProtectedRoute>
                    <MyList />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/dashboard"
                element={
                  <ProtectedRoute>
                    <Dashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin"
                element={
                  <AdminRoute>
                    <Admin />
                  </AdminRoute>
                }
              />
            </Routes>
          </BrowserRouter>
          <Toaster />
        </MyListProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
